(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chotto-editorial-page"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('chotto-photo-slider')) {
  customElements.define('chotto-photo-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const track = this.querySelector('.chotto-photo-slider__track');
      const count = this.querySelector('.chotto-photo-slider__count');
      const buttons = this.querySelectorAll('button');
      const update = () => {
        const index = Math.round(track.scrollLeft / (track.clientWidth || 1));
        count.textContent = (index + 1) + ' / ' + track.children.length;
        buttons[0].disabled = index === 0;
        buttons[1].disabled = index >= track.children.length - 1;
      };
      buttons.forEach(button => button.addEventListener('click', () => {
        track.scrollBy({left: Number(button.dataset.direction) * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }));
      track.addEventListener('scroll', update, {passive:true});
      update();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
